import { ModuleNameToModuleRegistry } from '../../types/types';
import { CustomerExperienceCard } from './components/CustomerExperienceCard';
import { EnterpriseCard } from './components/EnterpriseCard';
import { SolutionsCard } from './components/SolutionsCard';

const homeBottomCards: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  li_home_aud_ent: EnterpriseCard,
  li_home_aud_cx: CustomerExperienceCard,
  li_home_aud_sol: SolutionsCard,
});

export default homeBottomCards;
